import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'
import { registerConsent } from '@/util/consent'
import { loadScript } from '@/util/load_script'

const VENDOR = 'INFONLINE'

export default class IVWTracking {
  constructor (document) {
    this.document = document
    this.trackSent = false
    // referenced in https://script.ioam.de/iam.js:357 #transmitData()
    // default mode 0 will trigger a document.write() which replaces all markup if called after a page finished loading
    // we append this script based on user consent, so we have to switch mode passed to #count() :557
    this.iamMode = 1
  }

  sendConfig (config, stage) {
    if (!config) { return }

    this.stage = stage
    config.sv = this.surveyOption(config.sv)
    config.st = this.mediaQuery()

    this.config = config

    registerConsent({ vendor: VENDOR, onAdd: this.onAdd.bind(this) })
  }

  onAdd () {
    this.load()
  }

  surveyOption (currentSetting) {
    if (currentSetting === 'ke') { return 'ke' }

    return MediaQuery.current === 'small' ? 'mo' : 'in'
  }

  mediaQuery () {
    if (MediaQuery.current === 'small') {
      return 'mobzeit'
    } else {
      return 'zeitonl'
    }
  }

  load () {
    if (!this.config) { return }

    if (this.stage === 'prod' && !this.trackSent) {
      loadScript('https://script.ioam.de/iam.js')
        .then(() => {
          if (window.iom && window.iom.c) {
            window.iom.c(this.config, this.iamMode)
            this.trackSent = true
          }
        })
        .catch((_response) => {}) // ignore errors while loading or executing tracking scripts
    } else if (!this.trackSent) {
      this.trackSent = true
      console.log('IVW added:', { config: this.config, stage: this.stage })
    }
  }
}

export const bind = () => {
  MediaQuery._init()

  return new IVWTracking(document)
}

global.IVWTracking = bind()
